import type { TransactionMode } from 'app/types/listing';
import type { Loan } from 'app/types/loan';
import { getListingTransactionMode } from 'app/lib/listing';

export function getFinancialImpactTransactionMode(loan: Pick<Loan, 'listing'>): TransactionMode {
  return getListingTransactionMode(loan.listing);
}

export function filterLoansByTransactionMode(loans: Loan[] | undefined, transactionMode: TransactionMode) {
  return loans?.filter((loan) => getFinancialImpactTransactionMode(loan) === transactionMode);
}
